import { Component, inject, signal } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatBadge } from '@angular/material/badge';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { RouterLink } from '@angular/router';
import { ResponsiveService } from '../../services/responsive.service';
import { APP_SECTIONS } from '../../app-navigation/domain/app-sections.registry';
import { AppSection } from '../../app-navigation/domain/app-section.model';
import { AccountService } from '../../../account/application/account.service';
@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    AsyncPipe,
    RouterLink,
    MatIcon,
    MatIconButton,
    MatBadge,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatDivider,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly responsiveService = inject(ResponsiveService);
  private readonly accountService = inject(AccountService);

  // TODO Only for menu load testing // move to sidenav-mobile
  // private readonly topToolbarManagerService = inject(TopToolbarManagerService);

  // public readonly topToolbarConfig = signal<ITopToolbarConfig | null>(null);

  public readonly isMobile = this.responsiveService.isMobile;

  public readonly account$ = this.accountService.account$;

  // TODO For demo purposes only, in the future implement for notifications or warnings. With value 0 it is not displayed
  public notificationDashboardCount = signal<number>(0);

  public readonly sections = Object.values(AppSection).map((section) => APP_SECTIONS[section].navLink);

  // TODO Only for menu load testing // move to sidenav-mobile
  // constructor() {
  //   effect(() => {
  //     this.loadConfig();
  //   });
  // }

  // private async loadConfig(): Promise<void> {
  //   try {
  //     const config = await this.topToolbarManagerService.getTopToolbarConfig();
  //     this.topToolbarConfig.set(config);
  //   } catch (error) {
  //     console.error('Error loading top toolbar config:', error);
  //     this.topToolbarConfig.set(null);
  //   }
  // }
  logout(): void {
    this.accountService.logout();
  }
}
